// src/hooks/useChecklistSinister.ts

import { useState } from "react";
import { useToast } from "../../../shared/hooks";
import { SinisterService } from "../../../shared/services/api/sinister/SinisterService";

export function useChecklistSinister() {
	const toast = useToast();

	const [checklist, setChecklist] = useState<any[]>([]);
	const [checkStatus, setCheckStatus] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [showButtonSendSinister, setShowButtonSendSinister] = useState(false);

	const fetchChecklist = async (id: string, busyProperty: string) => {
		try {
			setIsLoading(true);

			const result = await SinisterService.getSinisterCheckList(id, busyProperty);

			if (result?.data) {
				const filtered = result.data.filter(
					(element: any) =>
						element.quant === "0" &&
						((busyProperty === "open" && element.open === "required") || (busyProperty === "busy" && element.busy === "required"))
				);

				setChecklist(result.data);
				setShowButtonSendSinister(true);

				const offResult = await SinisterService.getListOff(id);
				setCheckStatus(offResult?.data === 0);
			}
		} catch (error: any) {
			toast.present({
				type: "error",
				messageOrContent: "Erro ao buscar checklist do sinistro",
				position: "top-center",
			});
		} finally {
			setIsLoading(false);
		}
	};

	return {
		checklist,
		checkStatus,
		showButtonSendSinister,
		isLoading,
		fetchChecklist,
	};
}
